import { createI18n } from 'vue-i18n'
import { Locale } from '@/models/locale'
import { datetimeFormats } from '@/user/helpers/i18n.helper.js'
import en from '@/user/languages/en.yaml'
import ja from '@/user/languages/ja.yaml'
import ko from '@/user/languages/ko.yaml'

const i18n = createI18n({
  locale: Locale.getLanguage(),
  fallbackLocale: Locale.getDefaultLanguage(),
  messages: {
    en,
    ja,
    ko,
  },
  datetimeFormats,
})

export default i18n
